<template>
  <div>
    <b-modal size="lg" no-close-on-backdrop hide-footer id="create" title="NOVA CONTA">
      <Create @success="paginate" :groupings="groupings" :banks="banks" />
    </b-modal>
    <b-modal size="md" no-close-on-backdrop hide-footer id="grouping" title="NOVO AGRUPAMENTO">
      <CreateGrouping @success="handleSuccessGrouping" />
    </b-modal>
    <div class="row">
      <div class="col-md-10 border">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pr-0 d-flex align-items-center">
            <h1 class="title-pages">CONTAS</h1>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pl-0 text-right pl-0">
            <v-btn v-if="permission('write', 'financial_account')" @click="$bvModal.show('grouping')"
              class="btn-add m-1"><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
              AGRUPAMENTO</v-btn>
            <v-btn v-if="permission('write', 'financial_account')" @click="$bvModal.show('create')"
              class="btn-add m-1"><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
              CONTA</v-btn>
          </div>
        </div>
        <b-overlay :show="loading" opacity="0.99">
          <div v-show="data.length > 0 || accounts.length > 0">
            <div class="row">
              <div class="col-md-2">Descrição</div>
              <div class="col-md-2">Banco</div>
              <div class="col-md-2">Agência</div>
              <div class="col-md-2">Número</div>
              <div class="col-md-2">Status</div>
              <div class="col-md-2">Ação</div>
            </div>
          </div>
          <div class="v-clean p-5 text-center" v-show="data.length == 0 && accounts.length == 0">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <div class="row">
          </div>
          <div class="" v-for="account in accounts" :key="account.id">
            <div class="row border-top">
              <div class="col-md-2">
                {{ account.account_nickname }}
              </div>
              <div class="col-md-2">{{ account.bank_name }}</div>
              <div class="col-md-2">{{ account.agency }}</div>
              <div class="col-md-2">
                {{ account.account }}
                {{ account.account_dv ? ` - ${account.account_dv}` : "" }}
              </div>
              <div class="col-md-1">
                <span>
                  <i :class="[
                    'fas fa-circle',
                    account.status == 1 ? 'color-green' : 'color-warning',
                  ]"></i>
                  {{ account.status == 1 ? "ATIVO" : "INATIVO" }}</span>
              </div>
              <div class="col-md-3">
                <b-modal
                  size="xl"
                  no-close-on-backdrop
                  hide-footer
                  :id="`edit-account-${account.id}`"
                  :title="`EDITAR CONTA: ${account.account_nickname}`"
                >
                  <Edit
                    @success="paginate"
                    :data="account"
                    :groupings="groupings"
                    :banks="banks"
                  />
                </b-modal>
                <b-modal size="md" hide-header-close no-close-on-backdrop hide-footer
                  :id="`delete-account-${account.id}`" :title="`EXCLUIR CONTA: ${account.account_nickname}`">
                  <Delete @success="paginate" @cancel="$bvModal.hide(`delete-account-${account.id}`)" :data="account"
                    :accounts="all_accounts" />
                </b-modal>
                <b-modal size="sm" no-close-on-backdrop hide-footer :id="`action-${account.id}`" title="AÇÕES">
                </b-modal>
                <v-btn v-if="permission('edit', 'financial_account')" class="mr-1 v-primary float-right" x-small
                  @click="editAccount(account)">EDITAR</v-btn>
                <v-btn v-if="
                    account.default == 0 &&
                    permission('remove', 'financial_account')
                  " class="mr-1 v-danger float-right" x-small @click="deleteAccount(account)">EXCLUIR</v-btn>
              </div>
            </div>
          </div>
          <div class="mb-2" v-for="grouping in filtered" :key="`${grouping.id}-${grouping.description}`">
            <div class="row">
              <div class="col-md-10" style="background-color: #eceff1">
                <span>{{ grouping.description }}</span>
              </div>
              <div class="col-md-2" style="background-color: #eceff1">
                <b-modal size="md" no-close-on-backdrop hide-footer :id="`edit-grouping-${grouping.id}`"
                  :title="`EDITAR AGRUPAMENTO: ${grouping.description}`">grouping
                  <EditGrouping @success="handleSuccessGrouping" :data="grouping" />
                </b-modal>
                <v-btn v-if="permission('edit', 'financial_account')" small class="v-primary"
                  @click="editGrouping(grouping)">EDITAR</v-btn>
              </div>
            </div>
            <!-- {{ grouping.data }} -->
            <div class="border-top" v-for="account in grouping.data" :key="account.id">
              <div class="row">
                <div class="col-md-2">
                  {{ account.account_nickname }}
                </div>
                <div class="col-md-2">{{ account.bank_name }}</div>
                <div class="col-md-2">{{ account.agency }}</div>
                <div class="col-md-2">{{ account.account }}</div>
                <div class="col-md-1">
                  <span :class="[
                      'p-1 noBorderRadius text-twelve',
                      account.status == 1 ? 'v-success' : 'v-danger',
                    ]">{{ account.status == 1 ? "ATIVO" : "INATIVO" }}</span>
                </div>
                <div class="col-md-3">
                  <b-modal size="lg" no-close-on-backdrop hide-footer :id="`edit-account-${account.id}`"
                    :title="`EDITAR CONTA: ${account.account_nickname}`">
                    <Edit @success="paginate" :data="account" :groupings="groupings" :banks="banks" />
                  </b-modal>
                  <b-modal size="md" hide-header-close no-close-on-backdrop hide-footer
                    :id="`delete-account-${account.id}`" :title="`EXCLUIR CONTA: ${account.account_nickname}`">
                    <Delete @success="paginate" @cancel="$bvModal.hide(`delete-account-${account.id}`)" :data="account"
                      :accounts="all_accounts" />
                  </b-modal>
                  <v-btn v-if="permission('edit', 'financial_account')" small class="v-primary"
                    @click="editAccount(account)">EDITAR</v-btn>
                  <v-btn v-if="permission('remove', 'financial_account')" small class="ml-2 v-danger"
                    @click="deleteAccount(account)">EXCLUIR</v-btn>
                </div>
              </div>
            </div>
            <!-- {{ /grouping.data }} -->
          </div>
        </b-overlay>
      </div>
      <div class="col-md-2">
        <h6>O que é conta?</h6>
        <p class="worksansr">
          A conta financeira
          <b>registra as operações que envolvem ativos financeiros e passivos
            realizadas na empresa</b>. Ou seja, indicam de onde o dinheiro entrou ou saiu.
        </p>
        <p class="worksansr">
          Contas podem ser contas bancárias ou não, por exemplo:
          <b>Banco Bradesco</b>, <b>Itaú</b>, <b>Caixa</b>, <b>Carteira</b>,
          <b>Caixa Administrativo</b>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Create from "./Accounts/Create";

import Edit from "./Accounts/Edit";

import Delete from "./Accounts/Delete";

import CreateGrouping from "./Accounts/Grouping/Create";

import EditGrouping from "./Accounts/Grouping/Edit";

import api from "../../../services/api";

import { getStatic } from "../../../lib/functions";

import permission from "../../../lib/permission";

export default {
  name: "Accounts",
  components: {
    Create,
    Edit,
    Delete,
    CreateGrouping,
    EditGrouping,
  },
  data() {
    return {
      groupings: [],
      accounts: [],
      all_accounts: [],
      banks: [],
      data: [],
      filtered: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,

    handleSuccessGrouping() {
      this.paginate();
      this.getGroupings();
    },
    filter(text) {
      let { data } = this;

      let filtered = data.filter(
        ({ name }) =>
          String(name).toLowerCase().indexOf(String(text).toLowerCase()) > -1
      );

      this.filtered = filtered;
    },
    async retrieve() {
      this.getGroupings();
      this.getAccounts();
      this.paginate();

      try {
        this.banks = (await getStatic("/banks", true)).banks;
      } catch (errors) {
        this.errors = errors;
      }
    },
    async getGroupings() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/grouping-all"
        );

        const { data } = response.data;

        this.groupings = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getAccounts() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/account-all"
        );

        const { data } = response.data;

        this.all_accounts = data;
      } catch (error) {
        console.log(error);
      }
    },
    async paginate() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/financial/configuration/account"
        );

        const { data, accounts } = response.data;

        this.data = data;
        this.filtered = data;
        this.accounts = accounts;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    editGrouping(grouping) {
      this.$bvModal.show(`edit-grouping-${grouping.id}`);
    },
    editAccount(account) {
      this.$bvModal.show(`edit-account-${account.id}`);
    },
    deleteAccount(account) {
      this.$bvModal.show(`delete-account-${account.id}`);
    },
  },
};
</script>
